import React from 'react';
import { Menu, Portal } from '@chakra-ui/react';
import { IconButton } from '@/components/ui/icon-button';
import { FiDownload, FiFileText, FiMoreVertical } from 'react-icons/fi';

interface SourceActionsMenuProps {
	/** Opens the document's records detail drawer in place over the chat. */
	onOpen: () => void;
	/** Presigned URL for the download action; omit to hide it (e.g. no download permission). */
	downloadUrl?: string;
}

/**
 * Overflow menu for a source card. "Open" reveals the document's records detail drawer; "Download"
 * is shown only when a presigned URL is available. The action set is expected to grow, which is why
 * this stays a menu rather than collapsing to a single button.
 */
const SourceActionsMenu: React.FC<SourceActionsMenuProps> = (props: SourceActionsMenuProps) => {
	const { onOpen, downloadUrl } = props;

	return (
		<Menu.Root positioning={{ placement: 'bottom-end' }}>
			<Menu.Trigger asChild>
				<IconButton
					type="button"
					size="xs"
					variant="ghost"
					flexShrink={0}
					aria-label="Source actions"
					color="fg.muted"
					_hover={{ bg: 'brand.muted', color: 'brand.fg' }}
				>
					<FiMoreVertical />
				</IconButton>
			</Menu.Trigger>
			<Portal>
				<Menu.Positioner>
					<Menu.Content minW="140px" borderRadius="xl">
						<Menu.Item value="open-document" borderRadius="lg" onClick={onOpen}>
							<FiFileText />
							Open
						</Menu.Item>
						{downloadUrl && (
							<Menu.Item
								value="download-file"
								borderRadius="lg"
								onClick={() => window.open(downloadUrl, '_blank', 'noopener,noreferrer')}
							>
								<FiDownload />
								Download
							</Menu.Item>
						)}
					</Menu.Content>
				</Menu.Positioner>
			</Portal>
		</Menu.Root>
	);
};

export default SourceActionsMenu;
